

export default [
    // *===============================================---*
    {
        path: '/websitebuilder/websitebuilder',
        name: 'websitebuilder',
        component: () => import('@/views/websitebuilder/websitebuilder.vue'),
        meta: {
            pageTitle: 'Website Builder',
            breadcrumb: [
                {
                    text: 'Website Builder',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/websitebuilder/configurewebsitebuilder',
        name: 'configurewebsitebuilder',
        component: () => import('@/views/websitebuilder/configurewebsitebuilder.vue'),
        meta: {
            pageTitle: 'Configure Website Builder',
            breadcrumb: [
                {
                    text: 'Website Builder',
                    active: true,
                },
            ],
        },
    },
]

